import { render, staticRenderFns } from "./InternalDossiers.vue?vue&type=template&id=73d34f7d&scoped=true"
import script from "./InternalDossiers.vue?vue&type=script&lang=js"
export * from "./InternalDossiers.vue?vue&type=script&lang=js"
import style0 from "./InternalDossiers.vue?vue&type=style&index=0&id=73d34f7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d34f7d",
  null
  
)

export default component.exports